module.exports = __webpack_public_path__ + "media/customizations/serranoeldorado/logo-new-005483bb11095036d5fc8157ec0d05ed.png";